import {
  refreshToken,
  clientAutoLoginCode,
  registeredClientCode,
  getInfoByAnthor,
  getAccessTokenByCodeValue,
  refreshTokenByRelogin,
  changeUser
} from '@/api/login'
import {
  getInfo,
  refreshUserToken,
  getMemberPackagesInfo
} from '@/api/center/index.js'
import {
  getToken,
  setToken,
  setExpiresIn,
  removeToken
} from '@/utils/auth'
import { checkUserFeatures } from "@/api/home";
import { sessionStorageCollection } from "@/utils/stroage";

import {getQRCode} from "@/api/center/ewm";

const readSessionJson = (key, fallback) => {
  const raw = sessionStorage.getItem(key);
  if (!raw || raw === 'undefined' || raw === 'null') {
    return fallback;
  }
  try {
    return JSON.parse(raw);
  } catch (error) {
    return fallback;
  }
};

const setSessionJsonIfChanged = (key, value) => {
  const next = JSON.stringify(value);
  if (sessionStorage.getItem(key) !== next) {
    sessionStorage.setItem(key, next);
  }
};

const setSessionCollectionIfChanged = (key, value) => {
  const next = value === undefined || value === null ? '' : String(value);
  if (sessionStorageCollection.get(key) !== next) {
    sessionStorageCollection.set(key, next);
  }
};

const applyUserProfile = (commit, user, currentRole, options = {}) => {
  commit('SET_USER', user);
  commit('SET_NAME', user.nickName);
  commit('SET_USER_NAME', user.userName);
  commit('SET_USER_ID', user.userId);
  commit('SET_DEPT_ID', user.deptId);
  commit('SET_SCHOOL_TYPE', user.schoolType);
  commit('SET_PHONENUMBER', user.phonenumber);

  if (currentRole && currentRole.length) {
    if (!options.requireSingleRole || currentRole.length === 1) {
      const role = currentRole[0];
      const deptName = role.deptName || (user.dept && user.dept.deptName) || '';
      const deptId = role.deptId || (user.dept && user.dept.deptId) || user.deptId || '';
      commit('SET_ROLE_NAME', role.roleName);
      commit('SET_ROLE_ID', role.roleId);
      commit('SET_DEPT_ROLE_NAME', deptName + '-' + role.roleName);
      commit('SET_LAST_LOGIN_RECORD', user.userId + '-' + deptId + '-' + role.roleId);
    }
  }

  const roleListSource = user.roleList || user.roles || [];
  if (roleListSource.length) {
    commit('SET_ROLE_LIST', roleListSource.map(role => ({
      name: role.roleName,
      deptName: role.deptName,
      value: `${role.deptId},${role.roleId}`
    })));
  }

  if (user.patriarchUser && Object.prototype.hasOwnProperty.call(user.patriarchUser, 'userName')){
    commit('SET_MAIN_ACCOUNT_INFO', user.patriarchUser);
    commit('SET_CHILD_ACCOUNT', !!user.patriarchUser);
  }else {
    commit('SET_MAIN_ACCOUNT_INFO', null);
    commit('SET_CHILD_ACCOUNT', false);
  }
};

const user = {
  state: {
    token: getToken(),
    user: null,// 用户信息
    name: '',
    userId: '',
    userName: '',
    deptId: sessionStorageCollection.get('deptId') || '',
    avatar: '',
    roles: [],
    roleList: [], // 用户角色+部门机构详细信息
    permissions: [],
    phonenumber: '',
    mainAccountInfo: null, // 家长登录用户的信息
    hasChildAccount: false, // 是否有子账号（是否是家长账号 绑定孩子）
    clientId: readSessionJson('clientId', ''),
    redirectUris: readSessionJson('redirectUris', ''),
    lastLoginRecord: sessionStorageCollection.get('lastLoginRecord') || '', // 上一次登录用户的信息（userId-deptId-roleId）
    
    // 部门与角色
    roleName: sessionStorageCollection.get('roleName') || '', // 当前角色名称
    roleId: sessionStorageCollection.get('roleId') || '',     // 当前角色id
    deptRoleName: sessionStorageCollection.get('deptRoleName') || '', // 当前部门角色名称
    
    // 会员与套餐
    isSuper: sessionStorageCollection.get('isSuper') === 'true' || false, // 用户是否是会员
    vipPackage: [],         // 当前用户会员套餐列表
    
    // 记录与学段
    schoolType: sessionStorageCollection.get('schoolType') || '', // 当前用户的学段年级
    currentClass: sessionStorageCollection.get('currentClass') || '', // 当前班级，如「四年级01班」
  },

  mutations: {
    SET_LAST_LOGIN_RECORD(state, lastLoginRecord) {
      if (!lastLoginRecord || lastLoginRecord === 'undefined' || lastLoginRecord === 'null') {
        return;
      }
      state.lastLoginRecord = lastLoginRecord
      setSessionCollectionIfChanged('lastLoginRecord', lastLoginRecord)
    },
    SET_TOKEN: (state, token) => {
      if (state.token === token) {
        return;
      }
      setToken(token);
      state.token = token
    },
    SET_EXPIRES_IN: (state, time) => {
      state.expires_in = time
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_USER_NAME: (state, userName) => {
      state.userName = userName
    },
    SET_USER_ID: (state, userId) => {
      state.userId = userId
    },
    SET_DEPT_ID: (state, deptId) => {
      state.deptId = deptId
      setSessionCollectionIfChanged('deptId', deptId)
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_ROLE_LIST: (state, roleList) => {
      state.roleList = roleList
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },
    SET_PHONENUMBER: (state, phonenumber) => {
      state.phonenumber = phonenumber
    },
    SET_USER: (state, user) => {
      state.user = user
    },
    SET_CLIENTID: (state, clientId) => {
      state.clientId = clientId
      setSessionJsonIfChanged('clientId', clientId)
    },
    SET_REDIRECTURIS: (state, redirectUris) => {
      state.redirectUris = redirectUris
      setSessionJsonIfChanged('redirectUris', redirectUris)
    },
    SET_MAIN_ACCOUNT_INFO: (state, userInfo) => {
      state.mainAccountInfo = userInfo
      setSessionJsonIfChanged('mainAccountInfo', userInfo)
    },
    SET_CHILD_ACCOUNT: (state, hasChildAccount) => {
      state.hasChildAccount = hasChildAccount;
      setSessionJsonIfChanged('hasChildAccount', hasChildAccount)
    },
    SET_SCHOOL_TYPE: (state, schoolType) => {
      if (!schoolType) {
        return;
      }
      state.schoolType = schoolType;
      setSessionCollectionIfChanged('schoolType', schoolType)
    },
    SET_IS_SUPER: (state, isSuper) => {
      state.isSuper = isSuper;
      setSessionCollectionIfChanged('isSuper', isSuper)
    },
    SET_ROLE_ID: (state, roleId) => {
      state.roleId = roleId;
      setSessionCollectionIfChanged('roleId', roleId)
    },
    SET_ROLE_NAME: (state, roleName) => {
      state.roleName = roleName;
      setSessionCollectionIfChanged('roleName', roleName)
    },
    SET_DEPT_ROLE_NAME: (state, deptRoleName) => {
      state.deptRoleName = deptRoleName;
      setSessionCollectionIfChanged('deptRoleName', deptRoleName)
    },
    SET_VIP_PACKAGE: (state, vipPackage) => {
      state.vipPackage = vipPackage;
    },
    SET_CURRENT_CLASS: (state, currentClass) => {
      state.currentClass = currentClass;
      setSessionCollectionIfChanged('currentClass', currentClass);
    }
  },
  actions: {
    // TODO 主要获取用户数据方法
    GetProfile({commit}) {
      return new Promise( (resolve, reject) => {
        getInfo().then(res => {
          let user = res.data;
          let currentRole = res.currRole;
          let currentClass = res.className;

          commit('SET_CURRENT_CLASS', currentClass);
          applyUserProfile(commit, user, currentRole);

          resolve(res);
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取微信公众号扫码绑定用户的二维码
    getWxCode() {
      return new Promise((resolve, reject) => {
        getQRCode().then(res => {
          if (res.data) {
            localStorage.setItem("wxQrCode", res.data.wxQrCode.ticket)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    reLogin({
      commit
    }, userParams) {
      return new Promise((resolve, reject) => {
        refreshTokenByRelogin(userParams).then(res => {
          if (res.code === 200 && res.data && res.data.accessToken) {
            commit('SET_TOKEN', res.data.accessToken);
            resolve()
          }else {
            reject(res.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    reLoginUser({
              commit
            }, userParams) {
      return new Promise((resolve, reject) => {
        changeUser(userParams).then(res => {
          if (res.code === 200 && res.data && res.data.accessTokenValue) {
            commit('SET_TOKEN', res.data.accessTokenValue);
            // 清除当前登录角色信息
            localStorage.removeItem('lastLoginRecord')
            localStorage.removeItem('loginRoleId')
            localStorage.removeItem('loginDeptId')
            sessionStorage.removeItem('loginRoleName');
            sessionStorage.removeItem('loginRoleId');
            resolve()
          }else {
            reject(res.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    /**登录三步走 start */
    Login({
      commit
    }, userParams) {
      return new Promise((resolve, reject) => {
        registeredClientCode(userParams).then(res => {
          if (res.code == 200) {

            commit('SET_USER',userParams.user);
            commit('SET_CLIENTID',userParams.clientId);
            commit('SET_REDIRECTURIS',userParams.redirectUris);

            let data = res.data
            let code = data.url.split('=')[1]
            //把这个code存起来 下次选角色以后再拿来用
            let params = {
              clientId: userParams.clientId,
              clientSecret: "BvdmQqGIwRXYKTlu",
              authorizationCodeValue: code,
              authorizationGrantType: 'code'
            }
            getAccessTokenByCodeValue(params).then(result => {
              if (result.code == 200) {
                let tokenData = result.data
                commit('SET_TOKEN', tokenData.accessTokenValue)
                resolve()
              } else {
                reject(result)
              }
            })
          } else {
            reject(res)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    //获取用户信息
    GetInfo({
      commit
    }) {
      return new Promise((resolve, reject) => {
        getInfoByAnthor({
          accessTokenValue: user.state.token
        }).then(res => {
          const user = res.data
          const currentRole = user.roles;
          applyUserProfile(commit, user, currentRole, { requireSingleRole: true });

          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 刷新token
    RefreshCurrentToken({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        refreshUserToken().then(res => {
          if (res.code === 200 && res.data && res.data.accessToken) {
            commit('SET_TOKEN', res.data.accessToken);
            dispatch('GetInfo');
            resolve();
          } else {
            reject(res.msg);
          }
        }).catch(error => {
          reject(error);
        });
      })
    },
    /**登录三步走end */
    // 退出系统
    LogOut({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        // logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_PERMISSIONS', [])
          commit('SET_IS_SUPER', false) // 清除会员状态
          localStorage.removeItem("deptId")
          localStorage.removeItem("userId")
          localStorage.removeItem("wxQrCode")
          sessionStorage.removeItem('loginRoleName');
          removeToken()
          sessionStorageCollection.remove('schoolType')
          sessionStorageCollection.remove('isSuper')
          sessionStorageCollection.remove('roleName')
          sessionStorageCollection.remove('deptRoleName')
          resolve()
        // }).catch(error => {
        //   reject(error)
        // })
      })
    },

    /**跳转第三方应用 start */
    clientAutoLogin({
      commit
    }, userParams) {
      return new Promise((resolve, reject) => {
        clientAutoLoginCode(userParams).then(res => {
          if (res.code == 200) {
            let data = res.data
            let code = data.url.split('=')[1]
            let params = {
              clientId: userParams.clientId,
              clientSecret: userParams.clientSecret,
              authorizationCodeValue: code,
              authorizationGrantType: 'code'
            }
            getAccessTokenByCodeValue(params).then(result => {
              if (result.code == 200) {
                let tokenData = result.data
                // commit('SET_TOKEN', tokenData.accessTokenValue)
                resolve(tokenData.accessTokenValue); // 返回访问令牌
              } else {
                reject(result)
              }
            })
          } else {
            reject(res)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({
      commit
    }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('SET_IS_SUPER', false) // 清除会员状态
        // 清除会话缓存
        sessionStorageCollection.remove('schoolType')
        sessionStorageCollection.remove('isSuper')
        sessionStorageCollection.remove('roleName')
        sessionStorageCollection.remove('deptRoleName')
        removeToken()
        resolve()
      })
    },

    // 刷新token
    RefreshToken({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        refreshToken(state.token).then(res => {
          setExpiresIn(res.data)
          commit('SET_EXPIRES_IN', res.data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    CheckUserFeatures({
      commit
    }) {
      return new Promise((resolve, reject) => {
        checkUserFeatures().then(res => {
          if (res.code === 200) {
            commit('SET_IS_SUPER', res.data);
            resolve(res.data);
          } else {
            reject(res);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 获取用户会员套餐信息
    GetMemberPackagesInfos({
      commit
    }) {
      return new Promise((resolve, reject) => {
        getMemberPackagesInfo().then(res => {
          if (res.code === 200 && res.data) {
            commit('SET_VIP_PACKAGE', res.data);
            resolve(res.data);
          } else {
            commit('SET_VIP_PACKAGE', []);
            resolve([]);
          }
        }).catch(error => {
          commit('SET_VIP_PACKAGE', []);
          reject(error);
        });
      });
    }
  }
}

export default user
